<template>
    <div class="expert-index max-content" οncοntextmenu="return false;" οndragstart="return false;">
        <top title="专家主页" color="#901D22"></top>
        <div class="header">
            <div class="expertInfo">
                <div class="image">
                    <img v-if="expertInfo.photo" :src="expertInfo.photo" alt="" onerror="common.imgError(1,event)">
                    <img v-else src="@/assets/images/defaultHead.png" alt="">
                </div>
                <div class="info_con flex">
                    <div class="info">
                        <span class="name">{{ expertInfo.name }}</span>
                        <!-- <span v-if="expertInfo.title">{{expertInfo.title}}</span> -->
                        <p v-if="expertInfo.company"><span>{{ expertInfo.company }}</span></p>
                        <p v-if="expertInfo.department"><span>{{ expertInfo.department }}</span></p>
                    </div>
                </div>
                <!-- <div class="watch">
                    <p>+ 关注</p>
            </div> -->
            </div>
            <div class="des">
                <p v-if="flag && expertInfo.des">简介：{{ subDes(expertInfo.des) }}<van-icon
                        v-if="expertInfo.des && expertInfo.des.length > 50" name="arrow-down" size="20px"
                        @click="flag = !flag" /></p>
                <p v-else-if="expertInfo.des">简介：{{ expertInfo.des }}<van-icon
                        v-if="expertInfo.des && expertInfo.des.length > 50" name="arrow-up" size="20px"
                        @click="flag = !flag" /></p>
            </div>
            <!-- <div class="fans">
                <p>访问量<span>2902</span>|&nbsp;&nbsp;&nbsp;&nbsp;粉丝<span>100</span></p>
            </div> -->
            <div>

            </div>

        </div>
        <van-tabs v-model="outer_active">
            <van-tab title="视频" class="video" v-if="records.length > 0">
                <div class="record" v-for="(item, index) in records" :key="index" @click="goRecord(item.id)">

                    <div class="banner"
                        :style="{ backgroundImage: 'url(' + item.screen_short + ')', backgroundSize: 'cover' }">
                        <img src="../../../assets/images/System/video_icon.png" />
                        <span class="time" style="left:3px" v-if="item.duration"><van-icon name="play-circle-o"
                                style="margin-right:2px;top: 2px;" />{{ formatSeconds(item.duration) }}</span>
                        <span class="time">{{ formatTime(item.start_at) }}</span>
                    </div>
                    <!-- <p>{{formatName(item.name)}}</p> -->
                    <p class="line-clamp-2">{{ item.name }}</p>
                    <p class="meeting-name" style="font-size:11px;">源自会议:</p>
                    <p class="meeting-name line-clamp-2">{{ item.meeting_name }}</p>
                </div>
            </van-tab>
            <van-tab title="相关会议">
                <div class="item" v-for="(item, index) in meetings" :key="index" @click="goDetail(item.id)">
                    <div class="content">
                        <div class="name">{{ item.name }}</div>
                        <p>{{ formatTime(item.start_at) }}~{{ formatTime(item.end_at) }}</p>
                    </div>
                    <div class="image">
                        <img :src="item.banner" />
                    </div>
                </div>
            </van-tab>
        </van-tabs>
    </div>
</template>
<script>
import { ExpertInformation, ExpertSchedule, WritersMeetings, WriterRecord } from '../../../config/interface.js'
import Top from '../components/Top'
export default {
    components: {
        Top
    },
    data() {
        return {
            outer_active: 0,
            writer_id: 0,
            expertInfo: {},
            flag: true,
            records: [],
            meetings: [],
            meeting_id: 0,
            meeting_status: 0,
        }
    },
    mounted() {
        this.writer_id = this.$route.query.writer_id ? this.$route.query.writer_id : this.$route.query.w_id;
        this.meeting_id = this.$route.query.meeting_id;
        this.meeting_status = this.$route.query.meeting_status || 0;
        this.getExpertInfo();
        this.getRecords();
        this.getMeetings();
        // 禁用右键
        document.oncontextmenu = new Function('event.returnValue=false');
        // 禁用选择
        document.onselectstart = new Function('event.returnValue=false');
        //禁用F12
        window.onkeydown = window.onkeyup = window.onkeypress = function (event) {
            // 判断是否按下F12，F12键码为123
            if (event.keyCode == 123) {
                event.preventDefault(); // 阻止默认事件行为
                window.event.returnValue = false;
            }
        }
        var threshold = 160; // 打开控制台的宽或高阈值
        // 每秒检查一次
        var check = setInterval(function () {
            if (window.outerWidth - window.innerWidth > threshold ||
                window.outerHeight - window.innerHeight > threshold) {
                // 如果打开控制台，则刷新页面
                window.location.reload();
            }
        }, 1000)

    },
    methods: {
        //专家信息
        getExpertInfo(id) {
            const url = ExpertInformation;
            const method = 'POST';
            let params = {
                writer_id: this.writer_id,
                meeting_id: this.meeting_id,
                meeting_status: this.meeting_status
            }
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        let data = res.data;
                        this.expertInfo = {
                            photo: data.photo,
                            name: data.name,
                            company: data.company,
                            title: data.title['name'],
                            positionName: data.title.name,
                            des: data.des
                        }
                        if (common.is_weixin()) {
                            common.wxShare("【" + data.name + "】的个人学术主页@血管资讯", '欢迎点击浏览【' + data.name + '】的个人主页，给您带来更全面的学术视频', data.photo);
                        }
                    }
                })
        },
        //视频
        getRecords() {
            const url = WriterRecord;
            const method = 'POST';
            let params = {
                writer_id: this.writer_id,
                meeting_id: this.meeting_id

            }
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        this.records = res.data;
                    }
                })
        },
        //会议
        getMeetings() {
            const url = WritersMeetings;
            const method = 'POST';
            let params = {
                writer_id: this.writer_id,
                meeting_id: this.meeting_id
            }
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        this.meetings = res.data;
                    }
                })
        },
        changeParentTabs(index, val) {
            this.tableData = this.scheduleData[val];
            this.parent_id = val;
        },
        changeChildTabs(value) {
            this.dateTime[this.parent_id] = value;
        },
        goDetail(meeting_id) {
            this.$router.push({
                path: '/vascularNews/meeting/live',
                query: { 'meeting_id': meeting_id }
            })

        },
        goRecord(id) {
            this.$router.push({
                path: '/vascularNews/expert/record',
                query: { 'id': id, 'name': this.expertInfo.name, 'avater': this.expertInfo.photo }
            })

        },

        subDes(str) {
            if (str) {
                return str.slice(0, 46);
            }
            return ''

        },
        formatName(str) {
            if (str && str.length > 20) {
                return str.slice(0, 20) + '...'
            }
            return str;
        },
        formatTime(str) {
            if (str) {
                return str.slice(0, 10)
            }
            return ''
        },
        formatSeconds(value) {
            if (value) {
                var secondTime = value; // 秒
                var minuteTime = 0; // 分
                var hourTime = 0; // 小时
                if (secondTime >= 60) {
                    minuteTime = parseInt(secondTime / 60);
                    secondTime = parseInt(secondTime % 60);
                    if (minuteTime >= 60) {
                        hourTime = parseInt(minuteTime / 60);
                        minuteTime = parseInt(minuteTime % 60);
                    }
                }
                var result = "" + (parseInt(secondTime) < 10 ? "0" + parseInt(secondTime) : parseInt(secondTime));

                // if (minuteTime > 0) {
                result = "" + (parseInt(minuteTime) < 10 ? "0" + parseInt(minuteTime) : parseInt(minuteTime)) + ":" + result;
                // }
                // if (hourTime > 0) {
                result = "" + (parseInt(hourTime) < 10 ? "0" + parseInt(hourTime) : parseInt(hourTime)) + ":" + result;
                // }
                return result;
            }
            return "";
        },
    }
}
</script>
<style scoped lang="scss">
.expert-index {
    width: 100%;
    height: 100%;
    background: #f4f4f4;

    .content {
        height: 70px;

        .name {
            height: 50px;
            letter-spacing: 0;
            overflow: hidden;
            display: -webkit-box;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            /*要显示的行数*/
            -webkit-box-orient: vertical;
        }
    }

    .header {
        background-image: url('../../../assets/images/System/expert_background.png');
        background-size: cover;

        .expertInfo {
            color: white;
            padding: 20px;
            display: flex;

            .image {
                width: 25%;
                padding-top: 10px;

                img {
                    width: 80px;
                    height: 80px;
                    border-radius: 50%;
                    -webkit-user-select: none;
                }
            }

            .info_con {
                width: 50%;
                flex: 1;
                padding: 5px 0;
                padding-left: 10px;
                flex-direction: column;
                justify-content: space-between;

                .info {
                    -webkit-user-select: none;

                    span {
                        font-size: 16px;

                    }

                    .name {
                        font-size: 20px;
                        font-weight: bold;
                    }

                    p {
                        // color:gray;
                        margin-top: 10px;

                        span {
                            background: #EE7E77;
                            padding: 3px 15px;
                            border-radius: 10px;
                            color: #EFBCB7;
                            font-size: 12px;
                        }

                    }
                }
            }

            .watch {
                width: 25%;
                display: flex;
                align-items: center;

                p {
                    background: #83392D;
                    padding: 3px 10px;
                    border-radius: 20px;
                    color: white;
                    font-size: 14px;
                    margin: 0 auto;
                }
            }
        }

        .des {
            color: white;
            padding: 0 20px 10px 20px;
            color: 14px;
            line-height: 20px;
            -webkit-user-select: none;
            position: relative;

            .van-icon {
                position: absolute;
                right: 15px;
                bottom: 12px;
            }
        }

        .fans {
            color: white;
            padding: 10px 20px 10px 20px;
            color: 14px;
            line-height: 20px;

            span {
                padding: 0 10px;
            }
        }
    }

    .item {
        margin: 10px;
        background: white;
        display: flex;
        border-radius: 0.2rem;

        img {
            width: 100%;
            border-radius: 0.2rem;

        }

        .image {
            width: 40%;
            margin: 10px;
        }

        .content {
            width: 60%;
            margin: 15px;
            position: relative;
            font-size: 16px;

            p {
                position: absolute;
                bottom: 0;
                font-size: 12px;
                color: rgb(170, 163, 163);
            }
        }
    }

    .video {
        margin: 1%;
        width: 99%;
        display: flex;
        flex-wrap: wrap;

        .record {
            background: white;
            width: 47%;
            display: inline-block;
            margin: 0 1% 2%;
            border-radius: 10px;
            padding-bottom: 10px;

            .banner {
                background: gray;
                width: 100%;
                height: 80px;
                border-radius: 10px 10px 0 0;
                position: relative;

                img {
                    position: absolute;
                    top: 0;
                    right: 0;
                    width: 40px;
                }

                span {
                    position: absolute;
                    right: 3px;
                    bottom: 0;
                    color: white;
                }
            }

            p {
                width: 100%;
                padding: 10px;
                font-size: 14px;
                line-height: 26px;
                height: 62px;
            }

            .meeting-name {
                padding: 0 10px;
                color: #adacac;
                height: auto;
                font-size: 12px;
                line-height: 20px;
            }
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/pages/VascularSystem/Expert/Index.vue